
export const MARTIAL_ARTS_STYLES = [
  "Aikido",
  "Boxing",
  "BJJ",
  "Capoeira",
  "Hapkido",
  "Judo",
  "Karate",
  "Kendo",
  "Kickboxing",
  "Krav Maga",
  "Kung Fu",
  "MMA",
  "Muay Thai",
  "Taekwondo",
  "Wrestling"
];

export const AGE_GROUPS = [
  "Children (5-12)",
  "Teens (13-17)",
  "Adults (18+)"
];

export const EXPERIENCE_LEVELS = [
  "Beginner",
  "Intermediate",
  "Advanced"
];
